"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var April = require("april");
var Carol = require("carol");
var _ = require("lodash");
var moment = require("moment");
var finding_1 = require("./libraries/finding");
var grouping_1 = require("./libraries/grouping");
var mapping_1 = require("./libraries/mapping");
var sorting_1 = require("./libraries/sorting");
function initCarolCampaign(store, force) {
    if (force === void 0) { force = false; }
    return __awaiter(this, void 0, void 0, function () {
        var campaignId, carolCampaign;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    campaignId = _.get(store.state.config, 'campaignId');
                    if (!((campaignId && force) ||
                        (campaignId && !_.get(store, 'state.carolCampaign.createdAt')))) return [3, 2];
                    return [4, Carol.client.campaignList(campaignId)];
                case 1:
                    carolCampaign = _a.sent();
                    carolCampaign ? store.commit('SET_CAROL_CAMPAIGN', carolCampaign) : _.noop();
                    _a.label = 2;
                case 2: return [2];
            }
        });
    });
}
exports.initCarolCampaign = initCarolCampaign;
function initTeaserOffers(store, force) {
    if (force === void 0) { force = false; }
    return __awaiter(this, void 0, void 0, function () {
        var campaignName, stateAprilCruises, results, carolCampaign, specialOffers, specialOffersOk, campaignId, aprilCruiseIds, pricePlanCodes, aprilCruises, cruisesEqual, priceModel, teaserOffers, sortedTeaserOffers, reducedTeaserOffers;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    campaignName = _.get(store.state.config, 'campaignName', undefined);
                    stateAprilCruises = store.state.aprilCruises;
                    if (_.get(store, 'state.teaserOffers') &&
                        store.state.teaserOffers.length > 0 &&
                        !force) {
                        return [2];
                    }
                    if (!campaignName) return [3, 2];
                    return [4, April.client.campaignCruisesByName(campaignName)];
                case 1:
                    results = _a.sent();
                    return [3, 5];
                case 2:
                    carolCampaign = store.state.carolCampaign;
                    specialOffers = _.get(carolCampaign, 'specialOffers');
                    specialOffersOk = specialOffers && specialOffers.length;
                    campaignId = specialOffersOk ? specialOffers[0].campaignId : undefined;
                    if (!campaignId) return [3, 4];
                    return [4, April.client.campaignCruisesById(campaignId)];
                case 3:
                    results = _a.sent();
                    return [3, 5];
                case 4:
                    console.info('no campaignId found!');
                    _a.label = 5;
                case 5:
                    aprilCruiseIds = [];
                    pricePlanCodes = [];
                    aprilCruises = _.filter(results, function (result) {
                        return result.itinerary &&
                            result.itinerary.length &&
                            result.itinerary[0].name
                            ? true
                            : false;
                    });
                    _.map(aprilCruises, function (cruise) {
                        pricePlanCodes.push(cruise.id);
                        aprilCruiseIds.push(cruise.cruiseID);
                    });
                    cruisesEqual = _.isEqual(aprilCruises, stateAprilCruises);
                    if (cruisesEqual) {
                        return [2];
                    }
                    priceModel = aprilCruises && aprilCruises.length ? aprilCruises[0].priceModel : undefined;
                    teaserOffers = mapCruisesAsTeasers(aprilCruises);
                    sortedTeaserOffers = sorting_1.Sorting.sortTeaserOffers(teaserOffers);
                    reducedTeaserOffers = reduceTeaserOffers(sortedTeaserOffers);
                    store.commit('SET_TEASER_OFFERS', sortedTeaserOffers);
                    store.commit('SET_TEASER_OFFERS_REDUCED', reducedTeaserOffers);
                    store.commit('SET_PRICE_MODEL', priceModel);
                    store.commit('SET_PRICEPLANCODES', _.uniq(pricePlanCodes));
                    store.commit('SET_APRIL_CRUISES_IDS', _.uniq(aprilCruiseIds));
                    return [2];
            }
        });
    });
}
exports.initTeaserOffers = initTeaserOffers;
function reduceTeaserOffers(teasers) {
    var reducedOffers = _.map(teasers, function (teaser) {
        var campaignFocus = teaser.cruises[0].campaignFocus;
        var teaserCruises = _.map(teaser.cruises, function (cruise) {
            return {
                cruiseId: cruise.code,
                flightConnection: cruise.flightConnection,
                flightInclusive: cruise.flightInclusive,
                price: cruise.price * 2,
            };
        });
        return {
            campaignFocus: campaignFocus,
            cruisesPricePlan: teaserCruises,
            routeName: teaser.routeName,
        };
    });
    var props = ['campaignFocus'];
    var order = ['desc'];
    var orderedOffers = _.orderBy(reducedOffers, props, order);
    return orderedOffers;
}
function mapCruisesAsTeasers(cruises) {
    var teaserRoutes = grouping_1.Grouping.groupCruisesByRoute(cruises);
    var teaserOffers = _.compact(_.map(teaserRoutes, function (teaserCruises) {
        var promoCruise = finding_1.Finding.findPromoCruise(teaserCruises);
        if (!promoCruise) {
            var promoCruiseAlt = finding_1.Finding.findPromoCruiseCheapest(teaserCruises);
            if (promoCruiseAlt) {
                var teaserOfferAlt = mapping_1.Mapping.mapTeaserOffer(promoCruiseAlt, teaserCruises);
                return teaserOfferAlt;
            }
            return;
        }
        var teaserOffer = mapping_1.Mapping.mapTeaserOffer(promoCruise, teaserCruises);
        return teaserOffer;
    }));
    return teaserOffers;
}
function initTimestamp(store) {
    return __awaiter(this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, April.client.timestamp()];
                case 1:
                    result = _a.sent();
                    if (!result) {
                        return [2];
                    }
                    return [4, store.commit('SET_TIMESTAMP', result.timestamp)];
                case 2:
                    _a.sent();
                    return [2];
            }
        });
    });
}
exports.initTimestamp = initTimestamp;
function initTimingStates(store) {
    return __awaiter(this, void 0, void 0, function () {
        var currentDate, campaign, startDate, endDate, startPrices, timingStates;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    currentDate = moment(store.state.timeStamp);
                    if (!store.state.carolCampaign) {
                        return [2];
                    }
                    campaign = store.state.carolCampaign;
                    startDate = campaign.campaignStart
                        ? moment(campaign.campaignStart)
                        : moment();
                    endDate = campaign.campaignEnd ? moment(campaign.campaignEnd) : moment();
                    startPrices = campaign.campaignTeaserPricesStart
                        ? moment(campaign.campaignTeaserPricesStart)
                        : moment();
                    timingStates = {
                        ended: currentDate.isSameOrAfter(endDate),
                        priceCommunicationStarted: currentDate.isSameOrAfter(startPrices),
                        started: currentDate.isSameOrAfter(startDate),
                    };
                    return [4, store.commit('SET_TIMING_STATES', timingStates)];
                case 1:
                    _a.sent();
                    return [2];
            }
        });
    });
}
exports.initTimingStates = initTimingStates;
function setStarted(store, started) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, store.commit('SET_TIMING_STATES', __assign({}, store.state.timingStates, { started: started }))];
                case 1:
                    _a.sent();
                    return [2];
            }
        });
    });
}
exports.setStarted = setStarted;
function setTimestamp(store, timeStamp) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, store.commit('SET_TIMESTAMP', timeStamp)];
                case 1:
                    _a.sent();
                    return [2];
            }
        });
    });
}
exports.setTimestamp = setTimestamp;
function setEnded(store, ended) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, store.commit('SET_TIMING_STATES', __assign({}, store.state.timingStates, { ended: ended }))];
                case 1:
                    _a.sent();
                    return [2];
            }
        });
    });
}
exports.setEnded = setEnded;
function setPriceCommunicationStarted(store, priceCommunicationStarted) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, store.commit('SET_TIMING_STATES', __assign({}, store.state.timingStates, { priceCommunicationStarted: priceCommunicationStarted }))];
                case 1:
                    _a.sent();
                    return [2];
            }
        });
    });
}
exports.setPriceCommunicationStarted = setPriceCommunicationStarted;
function resetStore(store) {
    store.commit('RESET_STATE');
}
exports.resetStore = resetStore;
function updateFilter(store, filter) {
    switch (filter.key) {
        case 'region':
            store.commit('SET_FILTER_REGION', filter.value);
            break;
        case 'timeFrom':
            store.commit('SET_FILTER_TIME_FROM', filter.value);
            break;
        case 'timeTo':
            store.commit('SET_FILTER_TIME_TO', filter.value);
            break;
        case 'travelDuration':
            store.commit('SET_FILTER_DURATION', filter.value);
            break;
    }
}
exports.updateFilter = updateFilter;
//# sourceMappingURL=actions.js.map